module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAt0lEQVQ4T+3TWw3CQBCF4a8KQEIdAA5AATgACygAHOAAJIADcFALOMABZJJt0gstTXhlnjazM//OOZnN/BhZT/8eu3R/x/xT7R/AJw82OHWYu8Wxetdl4hnrBuSKVRPcBRjjhklqeGCK51BA1OUoMMIsnVvKygleOCCWpxoxcoBqulNdLFn2DdC1qOWW1gCheTHwa1ywrE5QJkJzy6gGNAwOQ8PYvJQQydAZeodEPBIyir7PNATkDTQ/JBG4Dff4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/xz.png
// module id = 405
// module chunks = 2